<template>
<div class="change-meter-container">
  <itemTable :API="API"></itemTable>
</div>
</template>

<script>
import { saveEntityAttributesV1 } from '@/api/telemetry-controller/' // deleteEntityAttributesV1
import { getDevicesAll } from '@/api/device-controller'
import itemTable from '@/views/layout/itemTable'
import changeMeterForm from './components/changeMeterForm'
const uuid = require('uuid/v1')

export default {
  name: 'changeMeterSetting',
  data () {
    return {
      API: {
        getter: getDevicesAll,
        getterParams: 'changeMeter',
        tableCols: ['start', 'end', 'opUser', 'description'],
        tableColsTextMap: new Map([
          ['start', '开始时间'],
          ['end', '结束时间'],
          ['opUser', '操作人'],
          ['description', '描述']
        ]),
        parser: function (val) {
          const data = []
          for (const item of val.data) {
            const info = JSON.parse(item.info)
            info.forEach(v => {
              const temp = {}
              temp.name = item.name
              temp.id = item.id.id
              temp.start = v.start
              temp.end = v.end
              temp.opUser = v.opUser
              temp.description = v.description
              temp.deleteId = uuid()
              data.unshift(temp)
            })
          }
          return data
          // return val.data
        },
        noEdit: true,
        dialog: {
          component: changeMeterForm,
          // dialogVisible: false,
          temp () {
            return {
              description: '',
              start: '',
              end: '',
              opUser: '',
              name: ''
            }
          }
        },
        // save: saveEntityAttributesV1
        save: function (val, originalList) {
          const deviceId = val.id
          const resultPromise = new Promise(function (reslove) {
            const list = []
            // 确认新添加设备是否已有换表记录
            const tempD = originalList.filter(v => { return v.id === deviceId })
            delete val.deleteId
            if (tempD.length > 0) {
              tempD.forEach(v => {
                const tempInfo = {}
                tempInfo.start = v.start
                tempInfo.end = v.end
                tempInfo.opUser = v.opUser
                tempInfo.description = v.description
                list.push(tempInfo)
              })
              list.push(val)
            } else {
              list.push(val)
            }

            saveEntityAttributesV1('DEVICE', deviceId, { changeMeter: JSON.stringify(list) }).then(res => {
              reslove(res)
            })
          })
          return resultPromise
        },
        deleter: function (delList, originalList) {
          const resultList = originalList.filter((oItem, i) => {
            for (const delItem of delList) {
              if (delItem.deleteId === oItem.deleteId) {
                return false
              }
            }
            return true
          })
          const deviceList = {}
          const resultObject = {}
          // 存为对象格式
          for (const item of resultList) {
            if (resultObject[item.id]) {
              resultObject[item.id].push(item)
            } else {
              resultObject[item.id] = []
              resultObject[item.id].push(item)
            }
          }
          // 对比原list，有该设备就赋值为已删除的item，没有就[]
          for (const item of originalList) {
            deviceList[item.id] = resultObject[item.id] || []
          }
          const promises = []
          for (const deviceAlarm in deviceList) {
            promises.push(saveEntityAttributesV1('DEVICE', deviceAlarm, { changeMeter: JSON.stringify(deviceList[deviceAlarm]) }).then(res => {
              // pass
            }))
          }
          return new Promise((reslove) => {
            Promise.all(promises).then(res => {
              reslove(res)
            })
          })
        }
      }
    }
  },
  components: {
    itemTable
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>
.change-meter-container {
  padding: 20px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>
